// Environment variables — all secrets live in .env
export const IMAGE_ANALYSIS_API_URL =
  import.meta.env.VITE_IMAGE_ANALYSIS_API_URL ||
  "http://localhost:5000/analyze-image";
export const IMAGE_ANALYSIS_API_KEY =
  import.meta.env.VITE_IMAGE_ANALYSIS_API_KEY || "";

export const REACT_APP_GOOGLE_MAPS_API_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";
